
import { Vue, Component, Prop } from "vue-property-decorator";

import PageHeadContainer from "@/components/page/PageHeadContainerNew.vue";
import PageHeadAvatar from "@/components/page/PageHeadAvatarNew.vue";
import PageHeadIcon from "@/components/page/PageHeadIcon.vue";
import LocationIcon from "@/components/icons/LocationIcon.vue";

import RouteNames from "@/entities/RouteNames";
import { User } from "@/interface";

@Component({
  components: {
    PageHeadContainer,
    PageHeadAvatar,
    PageHeadIcon,
    LocationIcon,
  },
})
export default class ContractorHeader extends Vue {
  @Prop({ type: Object, required: true }) readonly contractorUser!: User;
  @Prop({ type: String, required: true }) readonly contractorFullName!: string;
  @Prop({ type: String, default: "" }) readonly country!: string;
  @Prop({ type: String, default: "" }) readonly state!: string;
  @Prop({ type: String, default: "" }) readonly city!: string;
  @Prop({ type: String, default: "" }) readonly address!: string;

  get contractorLocation(): string {
    return [this.city, this.state, this.country]
      .filter((place) => Boolean(place))
      .join(", ");
  }

  message(): void {
    this.$router.push({
      name: RouteNames.INBOX,
      query: {
        recipientUserId: this.contractorUser.id,
      },
    });
  }
}
